import { Field } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './radioOptionSelector.scss';

function RadioOptionSelector(props) {
  const { label, name, value, options, children } = props;

  return (
    <fieldset className={styles.fieldset}>
      <h3 className={styles.labelHeading}>{label}</h3>
      <div className={styles.radioGroup}>
        {options.map((option, index) => {
          const inputId = name + option.get('id');

          return (
            <div key={index} className={styles.radioWrapper}>
              <Field
                id={inputId}
                className={styles.radioInput}
                name={name}
                value={option.get('value')}
                type={'radio'}
                checked={value === option.get('value')}
              />
              <label className={styles.radioLabel} htmlFor={inputId}>
                {option.get('label')}
              </label>
            </div>
          );
        })}
        {children}
      </div>
    </fieldset>
  );
}

RadioOptionSelector.propTypes = {
  optionClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.any,
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.func,
  ]),
};

export default RadioOptionSelector;
